export const Reply = ({ width = '16', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M5.59961 14.0001C6.28134 14.0001 6.63756 13.0145 6.22619 12.3775L6.16529 12.2929L5.14495 11.0169C5.94074 10.4078 7.09076 10.0001 8.39961 10.0001C10.8152 10.0001 12.6898 11.389 12.795 12.8692L12.7996 13.0001C12.7996 13.5523 13.1578 14.0001 13.5996 14.0001C14.0414 14.0001 14.3996 13.5523 14.3996 13.0001C14.3996 10.11 11.6567 8.00005 8.39961 8.00005C6.67636 8.00005 5.09705 8.59065 3.99175 9.57492L2.96529 8.29294C2.48323 7.69037 1.67386 8.07238 1.6044 8.88642L1.59961 9.00005V13.0001C1.59961 13.5129 1.90844 13.9356 2.30631 13.9933L2.39961 14.0001H5.59961Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
